import {
  createReverseContext,
  ReverseContext,
} from "./hooks/useReverseContext";

export interface DataTableReverseContextType {
  data: unknown[];
  visibleFields: string[];
}

export const dataTableReverseContext =
  createReverseContext<DataTableReverseContextType>();

export const getAllTablesData = <T,>(
  context: ReverseContext<DataTableReverseContextType>
): T[] => {
  // Collect all data from the context
  const allData: unknown[] = [];
  for (const { data } of context.values()) {
    allData.push(...data);
  }
  return allData as T[];
};

export const getAllTableVisibleFields = (
  context: ReverseContext<DataTableReverseContextType>
): string[] => {
  // Collect all visible fields from the context
  const allVisibleFields: string[] = [];
  for (const { visibleFields } of context.values()) {
    allVisibleFields.push(...visibleFields);
  }
  return [...new Set(allVisibleFields)]; // Remove duplicates
};

export const getFirstTableData = (
  context: ReverseContext<DataTableReverseContextType>
): unknown[] => {
  const tableData = context.values()[0];
  if (tableData) {
    return tableData.data;
  }
  return [];
};

export const getFirstTableVisibleFields = (
  context: ReverseContext<DataTableReverseContextType>
): string[] => {
  const tableData = context.values()[0];
  if (tableData) {
    return tableData.visibleFields;
  }
  return [];
};
